import {createReducer} from '@reduxjs/toolkit';
import {getCurrentUserSuccess} from 'src/openapi/apis/UserControllerApi';
import {User} from 'src/openapi/models/User';

import {LocalStorage} from '@pb/kit-util-client-storage';

type State = {
    data: User | null,
};

const defaultState = {
    data: null,
};

export const user = createReducer<State>(defaultState, builder => builder
    .addCase(getCurrentUserSuccess, (state, action) => {
        state.data = {...action.payload.data};
        LocalStorage.set('user', {...action.payload.data});
    }),
);
